import type { RouteRecordRaw } from 'vue-router'

export default function getGetAwayCheckoutRoutes(): Array<RouteRecordRaw> {
  return [
    {
      name: 'get-away-start',
      path: '/:lang?/purchase/start',
      component: () => import('~/core/pages/checkout/get-away/Start.page.vue'),
      meta: {
        layout: 'checkout',
      }
    },
    {
      name: 'get-away-buyer',
      path: '/:lang?/purchase/:packagepurchaseuuid/checkout/buyer',
      component: () => import('~/core/pages/checkout/get-away/Buyer.page.vue'),
      meta: {
        layout: 'checkout',
      }
    },
    {
      name: 'get-away-payment',
      path: '/:lang?/purchase/:packagepurchaseuuid/checkout/payment',
      component: () => import('~/core/pages/checkout/get-away/Payment.page.vue'),
      meta: {
        layout: 'checkout',
      }
    },
    {
      name: 'get-away-confirmation',
      path: '/:lang?/purchase/:packagepurchaseuuid/confirmation',
      component: () => import('~/core/pages/checkout/get-away/Confirmation.page.vue'),
      meta: {
        layout: 'thanks',
      }
    },
    {
      name: 'get-away-ko',
      path: '/:lang?/purchase/:packagepurchaseuuid/ko',
      component: () => import('~/core/pages/checkout/get-away/KO.page.vue'),
      meta: {
        layout: 'checkout',
      }
    },
  ]
}
